export type Language = 'nl' | 'en'

export const LANGUAGES: { code: Language; label: string; htmlLang: string }[] = [
  {
    code: 'nl',
    label: 'NL',
    htmlLang: 'nl-NL',
  },
  {
    code: 'en',
    label: 'EN',
    htmlLang: 'en',
  },
]

export const DEFAULT_LANGUAGE: Language = 'nl'
